/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
import { BaseModal } from "newcar-ui/output/es/components/AskpricePublicModal";
import { tools } from "newcar-ui/output/es/utils";
import { Prompt } from 'newcar-ui/output/cjs/components/Prompt'
let init = false;
/* 自动弹窗 1*/
const TopSlotPop = React.memo((props) => {
  return (
    <div className="top-slot-node-pop">
      <div className="echats-title">{props.finalPriceInfo.title}</div>
      <div className="modal-subtitle" >
        <div className="subtitle-text" >
          {props.finalPriceInfo.subTitle}
        </div>
      </div>
    </div>
  );
});
// 2
const TopCall = React.memo((props) => {
  return (
    <div className="top-slot-node-top">
      拨打本地经销商电话，咨询当日最新报价
    </div>
  );
});
/** 配置差异 3 */
const TopSlotPKNode = React.memo((props) => {
  return (
    <div className="top-slot-node-pk">
      <div className="modal-subtitle">
        咨询两款车配置差异
      </div>
    </div>
  );
});
/* 经销商*/
const MidSlotNode = React.memo((props) => {
  return (
    <div className="mid-slot-node">
      <div className="dealer-list" id="dealer">
        {props.chatsData.dealer.length > 0 &&
          props.chatsData.dealer.map((item, index) => {
            return (
              <div className="dealer-item" key={index}>
                <div className="item-left">
                  <div className="item-left-top">{item.dealerFullName}</div>
                  <div className="item-left-bottom">{item.dealerAddress}</div>
                </div>
                <div
                  className="item-right"
                  onClick={() => props.callDealer(item.dealerId)}
                ></div>
              </div>
            );
          })}
      </div>
    </div>
  );
});

const Index = () => {
  /** 车型信息 */
  const [chatsData, setChatsData] = useState({});
  const [fCode, setFCode] = useState("");
  const [finalPriceInfo, setFinalPriceInfo] = useState({ title: "", subTitle: "" });
  // 1 查成交价  2 经销商
  const [type, setType] = useState(null);
  // 有没有经销商
  const [hasDealer, setHasDealer] = useState(false);
  // 有没有经销商
  const [titleType, setTitleType] = useState('');
  const [eventId, setEventId] = useState("147");
  // 是展示城市
  const [cityShow, setCityShow] = useState(true);
  const [bannedDisplayModule, setBannedDisplayModule] = useState(["name"]);
  // 车系ID
  const [lineId, setLineId] = useState("3597");
  const [productId, setProductId] = useState("");
  const [multiProductId, setMultiProductId] = useState("");
  // 是否展示选择车型弹窗
  const [tipShow, setTipShow] = useState(false);
  const [checkProductId, setCheckProductId] = useState("");
  const [defaultProId, setDefaultProId] = useState("");
  /* 经销商控制滑动 */
  // eslint-disable-line
  const [autoScrollId, setAutoScrollId] = useState("dealer");
  /** 城市信息 */
  const [cityInfo, setCityInfo] = useState({
    cid: "",
    name: ""
  });
  /** 查成交价弹窗显示 */
  const [showFinalPriceModal, setShowFinalPriceModal] = useState(false);
  const changeClick = useCallback(() => {
    setPopShow(true);
  }, []);
  const selectedCityFn = useCallback((cityInfo) => {
    setCityInfo(cityInfo);
    localStorage.setItem('seoCarltypePK_cityInfo', JSON.stringify(cityInfo))
  }, []);
  useEffect(() => {
    window.showLineModalAskPriceAll = onShowFinalPriceModal;
  }, []);
  /** 显示查成交价弹窗 */
  const onShowFinalPriceModal = useCallback(
    (
      from = "",
      lineId = "",
      productId = "",
      type,
      eventId = "",
      defaultProId = "",
      subType = 2,
      titleType = ""
    ) => {
      if ((productId + '').indexOf(',') > -1) {
        setMultiProductId(productId)
        setProductId('')
      } else {
        setMultiProductId('')
        setProductId(productId)
      }
      if (showModalTimer && type != 1) {
        clearTimeout(showModalTimer);
        showModalTimer = '';
      }
      // 预约试驾 经销商 文案
      setTitleType(titleType);
      /* 区分不同弹窗类型 */
      setDefaultProId(defaultProId);
      /* 设置车系 */
      setLineId(lineId);
      setEventId(eventId);
      from && setFCode(from);
      let requestURL;
      //  1自动弹窗 2经销商电话 3配置差异
      if (type == 1) {
        const str = tools.getCookie(`carpkPopFormBottom_${lineId}`)
        if (tools.getCookie(`carpkPopFormBottom_${lineId}`) == 1) {
          return
        }
        requestURL = "//service.58che.com/unify/v1/popup/";
        setBannedDisplayModule(["name", "code"]);
        setCityShow(false);
      } else if (type == 2) {
        requestURL = "//service.58che.com/unify/v1/dealerPriceChart/";
        setCityShow(false);
        setBannedDisplayModule([
          "name",
          "tel",
          "code",
          "submit",
          "privacy"
        ]);
      } else if (type == 3) {
        setBannedDisplayModule(["name", "code"]);
        setCityShow(true);
      }
      // setShowFinalPriceModal(true);
      // return
      window.getCity((cityInfo_) => {
        let cityInfo_temp;
        if (init == false) {
          setCityInfo({ cid: cityInfo_.cityid, name: cityInfo_.name });
          init = true;
          cityInfo_temp = { cid: cityInfo_.cityid, name: cityInfo_.name };
          localStorage.setItem('seoCarltypePK_cityInfo', JSON.stringify({ cid: cityInfo_.cityid, name: cityInfo_.name }))
        } else {
          cityInfo_temp = JSON.parse(localStorage.getItem('seoCarltypePK_cityInfo'))
        }
        if (type == 3) {
          setHasDealer(true);
          setCityShow(true);
          setType(type);
          setShowFinalPriceModal(true);
          return
        }
        tools
          .request(
            requestURL,
            type == 1 ?
            {
                productId: productId || "",
              lineId: lineId || "",
                cityId: cityInfo_temp.cid,
                _type: "mPicDetailPopup",
              } : {
                productId: productId || "",
                lineId: lineId || "",
                cityId: cityInfo_temp.cid,
                subType: 2,
                defaultProId: 0,
            },
            "jsonp",
            { method: "get" }
          )
          .then(
            (res) => {
              if (res.code == 0) {
                if (type == 1) {
                  setFinalPriceInfo(res.entity.data);
                  setCityShow(true);
                  setType(type);
                  setShowFinalPriceModal(true);
                } else if (type == 2) {
                  setProductId(res.entity.data.productId);
                  setChatsData(res.entity.data);
                  setType(type);
                  setShowFinalPriceModal(true);
                }
              }
            },
            (error) => {
              console.log("error:", error);
            }
          );
      });

    },
    []
  );
  const onCloseFinalPriceModal = useCallback(() => {
    setShowFinalPriceModal(false);
  }, []);
  const onSubmitCheckedFn = useCallback(
    (info) => {
      tools.sendClickStatistics_wmda(eventId, {
        actiontype: "click",
        pagetype: "prd",
        page: "line-index",
        from_code: tools.getCookie("from") || "",
        cateid: "4,398038",
        reffer: document.referrer,
        url: window.location.href,
        line_id: info.lineId || "",
        product_id: info.productId || ""
      });
    },
    [eventId]
  );
  const onSubmitSuccessFn = useCallback(
    (formdata, result) => {
      // if (type == 3) {
        setTipShow(true);
        setTimeout(() => {
          setTipShow(false);
          setShowFinalPriceModal(false);
        }, 2000);
        return new Promise(function (resolve, reject) {
          resolve(true);
        })
    },
    [type, lineId]
  );
  // 拨打电话
  const callDealer = useCallback(
    (dealerId) => {
      const params = {
        dealerId: dealerId,
        lineId: lineId,
        platform: "m",
        uuId: tools.getCookie("58tj_uuid"),
        windowPop: 0,
        linkFrom: tools.getCookie("from_code"),
        source58: null,
        type: "",
        isFrom: fCode || 681
      };
      tools.sendClickStatistics_wmda(214, {
        actiontype: "click",
        pagetype: "prd",
        page: "line-index",
        from_code: tools.getCookie("from") || "",
        cateid: "4,398038",
        reffer: document.referrer,
        url: window.location.href,
        line_id: lineId || "",
        // fCode: fCode || ""
      });
      tools
        .request(
          "//service.58che.com/internal/v1/dealercall/",
          params,
          "jsonp",
          { method: "get" }
        )
        .then(
          (res) => {
            if (res.code == 0 && res.entity.data && res.entity.data.tel) {
              window.location = "tel:" + res.entity.data.tel;
            } else {
              alert("接口繁忙，请您稍后再试！");
            }
          },
          (error) => {
            console.log("error:", error);
          }
        );
    },
    [lineId, fCode]
  );
  return (
    <div>
      <BaseModal
        visible={showFinalPriceModal}
        bannedDisplayModule={bannedDisplayModule}
        autoScrollId={autoScrollId}
        topSlotNode={type == 1 ? <TopSlotPop finalPriceInfo={finalPriceInfo} /> : (type == 2 ?
          <TopCall /> : <TopSlotPKNode />)
        }
        midSlotNode={type == 2 ?
          <MidSlotNode
            chatsData={chatsData}
            callDealer={callDealer}
          /> : null
        }
        closeFun={onCloseFinalPriceModal}
        fCode={fCode}
        prodInfoRelate={{
          showProdArea: false,
          productId: productId,
          lineId: lineId
        }}
        titleRelate={{
          mainTitleShow: false,
          btnMainTitle: type == 1 ? "获取最低成交价" : "立即咨询",
          btnBotTitle:
            type == 3
              ? "专业顾问24小时为您提供最新报价和配置差异"
              : ""
        }}
        contentCn={"linecars"}
        modalCn="newcar-modal-wrap"
        cityinfoRelate={{
          show: cityShow,
          selectedCityFn: selectedCityFn,
          defaultCityInfo: {
            cityid: cityInfo.cid,
            cityname: cityInfo.name
          }
        }}
        submitRelate={{
          onSubmitCheckedFn: onSubmitCheckedFn,
          onSubmitSuccessFn: onSubmitSuccessFn,
          ajaxParams: { checkType: 0, multiProductId: multiProductId, name: `${cityInfo.name}用户` }
        }}
      />
      <Prompt show={tipShow} tipStr="咨询成功，稍后工作人员会与您联系讲解配置差异。" ></Prompt>
    </div>
  );
};

export default Index;
